import moment from 'moment-timezone';

export function capitalizeFLetter(s: string): string {
  if (!s) {
    return '';
  }
  // let _s: any = s;

  return `${s.charAt(0).toUpperCase()}${s.slice(1)}`;
}

export function formatCurrency(n: any, isUnit?: boolean): string {
  if (n === 0) {
    return `0`;
  }
  if (!n) {
    return '';
  }
  return n.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

export function parseCurrencyToValue(text: string): string {
  text = text.toString();
  if (!text || !text.trim()) {
    return '';
  }
  return text.replace(/[-,$S]/gi, '');
}
export function formatCurrencyFullText(
  text: string,
  negative?: boolean,
  unit = 'S$',
) {
  if (!text || typeof text !== 'string') {
    return '';
  }

  text = text.toString();
  if (text.indexOf('.') >= 0) {
    // get position of first decimal
    // this prevents multiple decimals from
    // being entered
    var decimal_pos = text.indexOf('.');

    // split number by decimal point
    var left_side = text.substring(0, decimal_pos);
    var right_side = text.substring(decimal_pos);

    // add commas to left side of number
    left_side = formatCurrency(left_side);

    // validate right side
    right_side = formatCurrency(right_side);

    // On blur make sure 2 numbers after decimal
    right_side += '00';

    // Limit decimal to only 2 digits
    right_side = right_side.substring(0, 2);

    // join number by .
    text = `${negative ? '-' : ''}${unit}${left_side}.${right_side}`;
  } else {
    // no decimal entered
    // add commas to number
    // remove all non-digits
    text = formatCurrency(text);
    text = `${negative ? '-' : ''}${unit}${text}`;

    // final formatting
    text += '.00';
  }

  return text;
}

export function msToTime(s: number) {
  const ms = s % 1000;
  s = (s - ms) / 1000;
  const secs = s % 60;
  s = (s - secs) / 60;
  const mins = s % 60;

  return `${mins < 10 ? `0${mins}` : `${mins}`}:${
    secs < 10 ? `0${secs}` : secs
  }`;
}

export function parseSubContent(data: any) {
  let parseData = data.replace(/<[^>]+>/g, ' ');

  if (parseData.length > 160) {
    return parseData.substring(0, 160) + '...';
  }
  return parseData;
}

export function parseUTCToTime(time: string, format = 'HH:mm, DD/MM/YYYY') {
  // const timeZone = moment.tz.guess();
  return moment(time).utc().tz('Asia/Singapore').format(format);
}

export function formatDate(value: any, format = 'DD MMM YYYY HH:mm') {
  if (!value) {
    return null;
  }
  let dateValue: any;
  if (value instanceof Date) {
    dateValue = value;
  } else {
    dateValue = new Date(value);
    if (isNaN(dateValue)) {
      return null;
    }
  }
  return moment(dateValue).format(format);
}
